// extracted by mini-css-extract-plugin
module.exports = {"container":"StartEarningPerksCTA_container__4eu4F","text":"StartEarningPerksCTA_text___kCNk"};